<template>
  <div
    class="cart-cont"
    :class="{
      'scroll-cont': courseList && courseList.length > 3,
      'cart-cont-mobile': isMobile,
      'cart-cont-pc': !isMobile,
    }"
  >
    <swiper :options="swiperOption" class="swiper-container users-swiper">
      <swiper-slide>
        <img
          class="icon"
          src="../../../assets/images/shopping-cart/title-icon.png"
          alt=""
        />
        <img
          class="hot-text"
          src="../../../assets/images/shopping-cart/hot-text.png"
          alt=""
        />
        <img
          class="icon"
          src="../../../assets/images/shopping-cart/title-icon.png"
          alt=""
        />
      </swiper-slide>
      <swiper-slide v-for="(user, index) in userList" :key="user + index">
        <p class="user-item">{{ user }}</p>
      </swiper-slide>
    </swiper>
    <ul class="course-list">
      <li
        @click="goDetail(item)"
        v-for="(item, index) in courseList"
        :key="item.course_id + index"
        class="course-item"
        :class="{ 'stop-offering': item.can_enrollment !== 0 }"
      >
        <div class="cover-wrap">
          <span class="index">{{ index + 1 }}</span>
          <img
            class="cover"
            :src="item.cover_url + '?imageView2/0/w/320'"
            alt=""
          />
        </div>
        <div class="info-wrap">
          <p class="name">{{ item.course_name }}</p>
          <div class="price-wrap">
            <p class="price"><span>￥</span>{{ item.real_price / 100 }}</p>
            <p v-if="showTotalPrice(item)" class="original-price">
              <span>￥</span>{{ item.total_price / 100 }}
            </p>
          </div>
        </div>
        <div class="operate-wrap">
          <button v-if="item.can_enrollment !== 0" class="stop-offer-btn">
            {{ item.can_enrollment === 1 ? "已停售" : "已售罄" }}
          </button>
          <button
            v-else
            class="sign-up-btn"
            @click.stop="jumpProductDetail(item.course_id)"
          >
            报名
          </button>
          <p class="enrollment-count">
            {{ handleEnrollmentCount(item) }}
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { isHXApp, isMobile, million } from "@saas/components";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import "swiper/css/swiper.css";
export default {
  props: {
    courseList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    userList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: function () {
    return {
      swiperOption: {
        slidesPerView: "auto",
        // speed: 1000,
        // loop: true,
        grabCursor: true,
        preventClicks: false,
        preventClicksPropagation: false,
        direction: "vertical",
        // autoplay: {
        //   delay: 2000,
        //   disableOnInteraction: false,
        // },
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，初始化swiper
        clickable: false,
      },
      isMobile: isMobile(),
      isHXApp: isHXApp(),
    };
  },
  methods: {
    goDetail(item) {
      let { course_id, can_enrollment } = item;
      if (this.isMobile && can_enrollment === 0) {
        this.jumpProductDetail(course_id);
      } else {
        return false;
      }
    },
    jumpProductDetail(course_id) {
      let url = `/product-detail/${course_id}`;
      if (this.isHXApp) {
        let params = {
          url: `${process.env.VUE_APP_SAAS_WEB_URL}${url}`,
        };
        let otherData = {
          name: "webViewBrowser",
        };
        jsToFlutter("openPage", params, otherData);
      } else if (window.isElectron || this.isMobile) {
        if (window.ReplyElectronApi) {
          // 视频播放页
          window.ReplyElectronApi.mainWinJumpUrl({
            name: "ProductDetails",
            params: {
              id: course_id,
            },
          });
        } else {
          this.$router.push(url);
        }
      } else {
        window.open(url);
      }
    },
  },
  computed: {
    handleEnrollmentCount() {
      return (item) => {
        if (item.show_enrollment_count === 1) {
          return `已售 ${million(item.sales_volume)}`;
        } else {
          return "火爆售卖中";
        }
      };
    },
    showTotalPrice() {
      return (item) => {
        return item.real_price !== item.total_price;
      };
    },
  },
  filters: {
    filterName(val) {
      if (val) {
        return val.substring(1, 0) + "****正在抢";
      }
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
};
</script>

<style lang="scss" scoped>
.cart-cont-pc {
  width: 500px;
  background: linear-gradient(
    346deg,
    #ffc4d3 0%,
    #ffdae8 61%,
    #fff0dc 120%,
    #fffae2 100%
  );
  border-radius: 15px;
  border: 2px solid #ffffff;
  padding: 12px 4px 12px 12px;
  overflow: hidden;
  .users-swiper {
    width: 100%;
    height: 33px;
    border-radius: 8px;
    border: 1px solid rgba(247, 202, 207, 0.75);
    margin-bottom: 10px;
    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .hot-text {
      width: 90px;
      height: 22px;
      margin: 0 18px;
    }
    .icon {
      width: 12px;
      height: 8px;
    }
    .user-item {
      position: relative;
      font-weight: 500;
      font-size: 18px;
      color: #ff0909;
      line-height: 22px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      &::before {
        width: 12px;
        height: 8px;
        content: "";
        position: absolute;
        left: -30px;
        top: 50%;
        transform: translateY(-50%);
        background: url("../../../assets/images/shopping-cart/title-icon.png")
          no-repeat center;
        background-size: 100% 100%;
      }
      &::after {
        width: 12px;
        height: 8px;
        content: "";
        position: absolute;
        right: -30px;
        top: 50%;
        transform: translateY(-50%);
        background: url("../../../assets/images/shopping-cart/title-icon.png")
          no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .course-list {
    max-height: 260px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .course-list {
    padding-right: 8px;
  }
  .course-list::-webkit-scrollbar {
    width: 4px;
  }
  .course-list::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 2px;
  }
  .course-item:last-child {
    margin-bottom: 0;
  }
  .course-item {
    // margin-right: 4px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 110px;
    background: #ffffff;
    border-radius: 12px;
    padding: 10px;
    .cover-wrap {
      position: relative;
      border-radius: 12px;
      overflow: hidden;
      .index {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        width: 26px;
        height: 15px;
        background: rgba($color: #000000, $alpha: 0.6);
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 15px;
        text-align: center;
        border-radius: 4px 0px 4px 0px;
      }
    }
    .cover {
      width: 160px;
      height: 90px;
      margin-right: 10px;
      border-radius: 12px;
      object-fit: cover;
    }
    .info-wrap {
      height: 100%;
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        width: 100%;
        font-weight: 500;
        font-size: 18px;
        color: #0d1400;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }
    .price-wrap {
      display: flex;
      align-items: center;
      .price {
        margin-right: 10px;
        font-weight: 500;
        font-size: 20px;
        color: #0d1400;
        line-height: 28px;
        span {
          font-size: 12px;
        }
      }
      .original-price {
        font-weight: 400;
        font-size: 16px;
        color: #858687;
        line-height: 22px;
        text-decoration-line: line-through;
      }
    }
    .operate-wrap {
      width: 75px;
      margin-left: 7px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .sign-up-btn {
        width: 56px;
        height: 28px;
        background: linear-gradient(
          133deg,
          #ff7a00 0%,
          #ff5037 37%,
          #ff2f9a 86%,
          #ff27c0 100%
        );
        border-radius: 8px;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        line-height: 28px;
        text-align: center;
      }
      .enrollment-count {
        margin-top: 10px;
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 20px;
      }
    }
  }
  .stop-offering {
    .cover-wrap,
    .info-wrap {
      opacity: 0.5;
    }
  }
  .stop-offer-btn {
    width: 56px;
    height: 28px;
    background: #b9b9b9;
    border-radius: 8px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
    cursor: not-allowed;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
  &.scroll-cont {
    .course-list {
      padding-right: 4px;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 500px;
      height: 69px;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffc3d2 100%
      );
    }
  }
}

.cart-cont-mobile {
  width: 100%;
  background: linear-gradient(
    346deg,
    #ffc4d3 0%,
    #ffdae8 61%,
    #fff0dc 120%,
    #fffae2 100%
  );
  border: none;
  border-radius: 0;
  padding: 0 0.32rem 0.32rem;
  overflow: hidden;
  .users-swiper {
    width: 5rem;
    height: 1.04rem;
    border-radius: 0rem 0rem 0.53rem 0.53rem;
    border: 0.01rem solid rgba(247, 202, 207, 0.75);
    margin-bottom: 0.29rem;
    .swiper-slide {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .hot-text {
      width: 2.67rem;
      height: auto;
      margin: 0 0.38rem;
    }
    .icon {
      width: 0.36rem;
      height: 0.24rem;
    }
    .user-item {
      position: relative;
      font-weight: 500;
      font-size: 0.4rem;
      color: #ff0909;
      line-height: 0.59rem;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      &::before {
        width: 0.36rem;
        height: 0.24rem;
        content: "";
        position: absolute;
        left: -0.88rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../../../assets/images/shopping-cart/title-icon.png")
          no-repeat center;
        background-size: 100% 100%;
      }
      &::after {
        width: 0.36rem;
        height: 0.24rem;
        content: "";
        position: absolute;
        right: -0.88rem;
        top: 50%;
        transform: translateY(-50%);
        background: url("../../../assets/images/shopping-cart/title-icon.png")
          no-repeat center;
        background-size: 100% 100%;
      }
    }
  }
  .course-list {
    min-height: 5.5rem;
    max-height: 11.48rem;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .course-list {
    padding-right: 0;
    //   padding-right: 0.24rem;
  }
  .course-list::-webkit-scrollbar {
    width: 0.11rem;
  }
  .course-list::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 0.05rem;
  }
  .course-item:last-child {
    margin-bottom: 0;
  }
  .course-item {
    margin-bottom: 0.27rem;
    display: flex;
    align-items: center;
    width: 100%;
    height: 2.21rem;
    background: #ffffff;
    border-radius: 0.32rem;
    padding: 0.24rem 0.27rem;
    .cover-wrap {
      position: relative;
      border-radius: 0.16rem;
      overflow: hidden;
      .index {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        width: 0.56rem;
        height: 0.4rem;
        background: rgba($color: #000000, $alpha: 0.6);
        font-weight: 500;
        font-size: 0.32rem;
        color: #ffffff;
        line-height: 0.4rem;
        text-align: center;
        border-radius: 0.08rem 0.08rem 0.08rem 0rem;
      }
    }
    .cover {
      width: 3.07rem;
      height: 1.73rem;
      margin-right: 0.16rem;
      border-radius: 0.16rem;
      object-fit: cover;
    }
    .info-wrap {
      height: 100%;
      width: 0;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .name {
        width: 100%;
        font-weight: 500;
        font-size: 0.4rem;
        color: #222426;
        line-height: 0.53rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }
    .price-wrap {
      display: flex;
      align-items: center;
      .price {
        margin-right: 0.16rem;
        font-weight: 500;
        font-size: 0.37rem;
        color: #f03349;
        line-height: 1;
        span {
          font-size: 0.21rem;
        }
      }
      .original-price {
        font-weight: 400;
        font-size: 0.32rem;
        color: #747573;
        line-height: 0.32rem;
        text-decoration-line: line-through;
      }
    }
    .operate-wrap {
      width: 1.65rem;
      margin-left: 0.19rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .sign-up-btn {
        width: 1.49rem;
        height: 0.75rem;
        background: linear-gradient(
          133deg,
          #ff7a00 0%,
          #ff5037 37%,
          #ff2f9a 86%,
          #ff27c0 100%
        );
        border-radius: 0.16rem;
        font-weight: 500;
        font-size: 0.4rem;
        color: #ffffff;
        line-height: 0.75rem;
        text-align: center;
        cursor: auto;
      }
      .enrollment-count {
        margin-top: 0.28rem;
        font-weight: 400;
        font-size: 0.32rem;
        color: #0d1400;
        line-height: 0.44rem;
      }
    }
  }
  .stop-offering {
    cursor: not-allowed;
    pointer-events: auto !important;
    cursor: not-allowed !important;
    .cover-wrap,
    .info-wrap {
      opacity: 0.5;
    }
  }
  .stop-offer-btn {
    width: 1.49rem;
    height: 0.75rem;
    background: #b9b9b9;
    color: #ffffff;
    border-radius: 0.16rem;
    font-weight: 500;
    font-size: 0.4rem;
    line-height: 0.75rem;
    text-align: center;
    cursor: not-allowed;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }
  &.scroll-cont {
    padding: 0 0.08rem 0.32rem 0.32rem;
    .course-list {
      padding-right: 0.13rem;
    }
  }
}
</style>
